import { render, staticRenderFns } from "./extFieldsSettings.vue?vue&type=template&id=93db8442&scoped=true&"
import script from "./extFieldsSettings.vue?vue&type=script&lang=js&"
export * from "./extFieldsSettings.vue?vue&type=script&lang=js&"
import style0 from "./extFieldsSettings.vue?vue&type=style&index=0&id=93db8442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93db8442",
  null
  
)

export default component.exports